interface NotesPagination {
    count: number;
    currentPage: number;
    totalCount: number;
    totalPages: number;
}

export function getNotesRecoveryPage({
    count,
    currentPage,
    totalCount,
    totalPages,
}: NotesPagination): number | null {
    if (
        count === 0 &&
        totalCount > 0 &&
        totalPages > 0 &&
        currentPage > totalPages
    ) {
        return totalPages;
    }

    return null;
}
